import React, { useState } from 'react';
import './Header.css';

/**
 * Kopfzeile mit Navigation. Die Logo‑Platzhalter kann von
 * Nutzerinnen und Nutzern durch ein eigenes Logo ersetzt werden.
 */
const AGB = () => {

  return (
    <div className="AGB">
AGB
    </div>
  );
};

export default AGB;